module.exports = __webpack_public_path__ + "img/redpack.adbb2b37.png";